import { Controller } from "@hotwired/stimulus"

// Scrolls to this element and flashes it when the page was opened with a link pointing at it, so
// somebody following "edit this provider's email domains" lands looking at the right thing rather
// than hunting down the page.
//
//   <div id="known-email-domains-123" data-controller="highlight-on-hash">
//
// Also fires on hashchange, so following the same link again while already on the page replays the
// flash instead of doing nothing (the browser won't reload for a same-page hash).
export default class extends Controller {
  static values = { duration: { type: Number, default: 2400 } }

  connect() {
    this.onHashChange = () => this.flashIfTargeted()
    window.addEventListener("hashchange", this.onHashChange)
    this.flashIfTargeted()
  }

  disconnect() {
    window.removeEventListener("hashchange", this.onHashChange)
    clearTimeout(this.timeout)
  }

  flashIfTargeted() {
    if (!this.element.id) return
    if (window.location.hash !== `#${this.element.id}`) return

    // A frame after paint: on a fresh load the browser is still settling layout and doing its own
    // anchor jump, and scrolling into the middle of that lands in the wrong place.
    requestAnimationFrame(() => requestAnimationFrame(() => this.flash()))
  }

  flash() {
    this.element.scrollIntoView({ behavior: "smooth", block: "center" })

    // Removed and re-added so a repeat visit restarts the animation rather than being a no-op.
    clearTimeout(this.timeout)
    this.element.classList.remove("highlight-flash")
    void this.element.offsetWidth
    this.element.classList.add("highlight-flash")
    this.timeout = setTimeout(() => this.element.classList.remove("highlight-flash"), this.durationValue)
  }
}
